import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "./baseUrl";
import ProductCard from "./ProductCard";

// Optional: Add CSS for the loader in your stylesheet or inline
const loaderStyles = `
 .loader {
    border: 4px solid #f3f3f3;
    border-top: 14px solid #3498db;
    border-radius: 50%;
    width: 230px;
    height: 230px;
    animation: spin 1s linear infinite;
    margin: 150px auto;
}

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
    .btn-outline-primary {
    color: #d60000 !important;
    border-color: #000000 !important;
}
    .btn-primary {
    color: #fff;
    background-color: #ff0031 !important;
    border-color: #000000 !important;

}
    .btn-outline-primary:hover {
    color: #fff !important;
    background-color: #ff0031 !important;
    border-color: #000000  !important;
}
`;

function Subcategory(props) {
  const [allproduct, setallProduct] = useState([]);
  const [subcategoryName, setSubCategoryName] = useState([]);
  const [modalDis, setModalDis] = useState(false);
  const [brands, setBrands] = useState([]);
  const [FilterName, setFN] = useState({
    type: [],
    wattage: [],
    size: [],
    filter_product: [],
    color: [],
    brand_data: [],
  });
  const [emptyMessage, setEmptyMessage] = useState("");
  const [type, settype] = useState("");
  const [wattage, setwattage] = useState("");
  const [size, setsize] = useState("");
  const [filter_product, setfilter_product] = useState("");
  const [color, setcolor] = useState("");
  const [model, setModel] = useState("");
  const [filter, setfilter] = useState("");
  const [brand, setbrand] = useState("");
  const [loading, setLoading] = useState(true); // New loading state

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const subcategory_id = window.location.pathname.substring(
    window.location.pathname.lastIndexOf("/") + 1
  );

  async function fetchAllProductData() {
    setLoading(true); // Set loading to true when fetching starts
    const formData = new FormData();
    const wsId = localStorage.getItem("selectedWorkingStateId");
    formData.append("subcategory_id", subcategory_id);
    if (wsId) {
      formData.append("w_s_id", wsId);
    }

    try {
      const data = await axios.post(
        baseUrl + "Apicontroller/get_subcategory_products",
        formData
      );
      setallProduct(data.data.data);
      setSubCategoryName(data.data.subcategory_name);
      setCurrentPage(1);
    } catch {
      console.log("Issue in get product detail.");
    } finally {
      setLoading(false); // Set loading to false when fetching completes
    }
  }

  async function getBrands() {
    setLoading(true); // Set loading to true
    try {
      let response = await axios.get(baseUrl + "Apicontroller/get_brands");
      if (response.data.status === 200) {
        setBrands(response.data.data);
      }
    } catch {
      console.log("Issue in get category.");
    } finally {
      setLoading(false); // Set loading to false
    }
  }

  async function fetchFilterNameData() {
    setLoading(true); // Set loading to true
    const selectedWorkingStateId = localStorage.getItem("selectedWorkingStateId");
    const wsId = selectedWorkingStateId ? selectedWorkingStateId : null;
    try {
      const response = await axios(
        baseUrl + "Apicontroller/view_filter/" + subcategory_id + "/" + wsId
      );
      if (response.data.status === 200) {
        setFN(response.data.data[0]);
        if (
          response.data.data[0].type.length > 0 ||
          response.data.data[0].wattage.length > 0 ||
          response.data.data[0].size.length > 0 ||
          response.data.data[0].filter_product.length > 0 ||
          response.data.data[0].color.length > 0 ||
          response.data.data[0].brand_data.length > 0
        ) {
          setfilter(1);
        } else {
          setfilter("");
        }
      }
    } catch {
      console.log("Issue in filter name");
    } finally {
      setLoading(false); // Set loading to false
    }
  }

  async function applyingFilterAPI() {
    if (type || wattage || size || filter_product || color || model || brand) {
      setLoading(true); // Set loading to true
      const appliedFilterData = new FormData();
      appliedFilterData.append("brand", brand);
      appliedFilterData.append("type_id", type);
      appliedFilterData.append("wattage_id", wattage);
      appliedFilterData.append("size_id", size);
      appliedFilterData.append("filter_product_id", filter_product);
      appliedFilterData.append("color_id", color);
      appliedFilterData.append("model", model);
      appliedFilterData.append("subcategory_id", subcategory_id);
      const workingState = localStorage.getItem("selectedWorkingStateId");
      const wsId = workingState ? workingState : "";
      appliedFilterData.append("w_s_id", wsId);

      try {
        const response = await axios.post(
          baseUrl + "Apicontroller/filter",
          appliedFilterData
        );
        if (response.data.status === 201) {
          setallProduct([]);
          setEmptyMessage("No product available.");
        } else {
          setallProduct(response.data.data);
          setEmptyMessage("");
          setCurrentPage(1);
        }
      } catch {
        console.log("Issue in get filtered data");
      } finally {
        setLoading(false); // Set loading to false
      }
    } else {
      fetchAllProductData();
    }
  }

  useEffect(() => {
    fetchAllProductData();
    getBrands();
    fetchFilterNameData(); // Call filter name fetch
  }, [subcategory_id]);

  useEffect(() => {
    applyingFilterAPI();
  }, [type, wattage, size, filter_product, color, model, brand]);

  const setFilters = (e) => {
    const filterId = e.target.getAttribute("filterid");
    const filterName = e.target.getAttribute("filtername");
    const updateFilter = (current, setFilter) => {
      if (e.target.checked) {
        if (current === "") {
          setFilter(filterId);
        } else {
          let newdata = current + "," + filterId;
          setFilter(newdata);
        }
      } else {
        if (current !== "") {
          let prevArray = current.split(",");
          let index = prevArray.indexOf(filterId);
          if (index > -1) {
            prevArray.splice(index, 1);
          }
          let newdata = prevArray.join();
          setFilter(newdata);
        }
      }
    };

    if (filterName === "brand") updateFilter(brand, setbrand);
    if (filterName === "type") updateFilter(type, settype);
    if (filterName === "wattage") updateFilter(wattage, setwattage);
    if (filterName === "size") updateFilter(size, setsize);
    if (filterName === "filter_product") updateFilter(filter_product, setfilter_product);
    if (filterName === "color") updateFilter(color, setcolor);
    if (filterName === "model") updateFilter(model, setModel);
  };

  const openFilter = () => {
    document.querySelector(".side_filter").style.transform = "translateX(0px)";
  };

  const closeFilter = () => {
    document.querySelector(".side_filter").style.transform = "translateX(900px)";
  };

  // Pagination Logic
  const totalPages = Math.ceil(allproduct.length / itemsPerPage);

  const getPageNumbers = () => {
    const delta = 2;
    const range = [];
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      } else if (
        (i === currentPage - delta - 1 && i > 1) ||
        (i === currentPage + delta + 1 && i < totalPages)
      ) {
        range.push("...");
      }
    }
    return range.filter((item, pos, arr) => item !== "..." || arr[pos - 1] !== "...");
  };

  const pages = getPageNumbers();

  const currentProducts = allproduct.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPage = (page) => {
    if (page === "...") return;
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const goFirst = () => setCurrentPage(1);
  const goLast = () => setCurrentPage(totalPages);
  const goPrev = () => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));
  const goNext = () => setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev));

  return (
    <div>
      {/* Inline CSS for loader */}
      <style>{loaderStyles}</style>

      {loading ? (
        <div className="loader"></div> // Display loader when loading is true
      ) : (
        <>
          <section className="filter pt-5 mt-5 accordion" id="accordionExample">
            <div className="container-fluid" style={{ maxWidth: "100vw" }}>
              <div className="row heading-div">
                <div className="col-md-12 text-center">
                  <h1 className="heading">{subcategoryName}</h1>
                </div>
              </div>
            </div>
          </section>
          <section className="filter_img mt-3">
            <div className="container-fluid px-4">
              <div className="d-block d-md-none mb-3">
                <div className="row d-flex text-right justify-content-end">
                  <div
                    className="col-5 py-2 d-flex text-right border justify-content-end"
                    onClick={() => openFilter()}
                  >
                    <div>
                      <p className="mb-0">Filters</p>
                    </div>
                    <div>
                      <i className="fa fa-filter px-2" style={{ fontSize: "1.4rem" }}></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div
                  className={
                    "col-md-3 col-12 desktopfilter " + (filter === 1 ? "d-block" : "d-none")
                  }
                >
                  {filter ? (
                    <div className="border p-2 mb-2">
                      <div className="text-center mb-2">
                        <h5>Filters</h5>
                      </div>
                      <div className="accordion filter_shopbycar" id="filter_shopbycar">
                        {/* Filter sections remain unchanged */}
                        {FilterName.brand_data.length > 0 && (
                          <div className="card">
                            <div className="card-header shopBycar" id="brand">
                              <h2
                                className="mb-0 d-flex w-100"
                                style={{ justifyContent: "space-around" }}
                                role="button"
                                data-toggle="collapse"
                                data-target="#collapse_brand"
                                aria-expanded="true"
                                aria-controls="#collapse"
                              >
                                <span
                                  style={{ fontSize: "1rem", margin: "auto", marginLeft: "0px" }}
                                  className="d-block"
                                >
                                  Brand
                                </span>
                                <button
                                  className="btn btn-link w-50 ml-auto text-end"
                                  type="button"
                                  style={{ textAlign: "end" }}
                                >
                                  <i className="fa fa-chevron-circle-down"></i>
                                </button>
                              </h2>
                            </div>
                            <div
                              id="collapse_brand"
                              className="collapse"
                              aria-labelledby="heading"
                              data-parent="#filter_shopbycar"
                            >
                              <div className="card-body shopBycar_item">
                                <ul style={{ fontSize: "20px" }} className="pl-0 mt-0 mb-0 mt-2">
                                  {FilterName.brand_data.map((elem, i) => (
                                    <li
                                      style={{ fontSize: "16px", transform: "none", display: "flex", alignItems: "baseline" }}
                                      key={elem.id}
                                    >
                                      <input
                                        type="checkbox"
                                        name="brand"
                                        className="CheckShopbycar"
                                        id={"brand" + elem.id}
                                        filterid={elem.id}
                                        filtername="brand"
                                        onClick={(e) => setFilters(e)}
                                      />
                                      <label htmlFor={"brand" + elem.id} className="mx-2 m-0">
                                        {elem.name}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* Other filter sections (type, wattage, size, etc.) remain unchanged */}
                        {/* ... */}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="col-md-9 col-12 p-0 px-2">
                  {allproduct.length > 0 ? (
                    <>
                      <div className="row">
                        {currentProducts.map((elem) => (
                          <ProductCard
                            key={elem.product_id}
                            product_id={elem.product_id}
                            productimage={elem.image ? elem.image : elem.product_image}
                            productname={elem.product_name}
                            mrp={elem.mrp ? elem.mrp : elem.MRP}
                            price={elem.price}
                            stock={elem.stock}
                            addingToCartFunction={props.addingToCart}
                            isSlider="false"
                          />
                        ))}
                      </div>
                      <div className="row mt-4">
                        <div className="col-12 d-flex justify-content-center align-items-center flex-wrap">
                          <button
                            className="btn btn-sm btn-outline-primary m-1"
                            onClick={goFirst}
                            disabled={currentPage === 1}
                          >
                            First
                          </button>
                          <button
                            className="btn btn-sm btn-outline-primary m-1"
                            onClick={goPrev}
                            disabled={currentPage === 1}
                          >
                            Prev
                          </button>
                          {pages.map((page, idx) =>
                            page === "..." ? (
                              <span key={"ellipsis_" + idx} className="mx-2">
                                ...
                              </span>
                            ) : (
                              <button
                                key={page}
                                className={`btn btn-sm m-1 ${
                                  currentPage === page ? "btn-primary" : "btn-outline-primary"
                                }`}
                                onClick={() => goToPage(page)}
                              >
                                {page}
                              </button>
                            )
                          )}
                          <button
                            className="btn btn-sm btn-outline-primary m-1"
                            onClick={goNext}
                            disabled={currentPage === totalPages || totalPages === 0}
                          >
                            Next
                          </button>
                          <button
                            className="btn btn-sm btn-outline-primary m-1"
                            onClick={goLast}
                            disabled={currentPage === totalPages || totalPages === 0}
                          >
                            Last
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="text-center w-100 mt-5">
                      <h5>{emptyMessage || "No Result Found"}</h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
          <section className="side_filter d-block d-md-none">
            {/* Mobile filter section remains unchanged */}
            {/* ... */}
          </section>
        </>
      )}
    </div>
  );
}

export default Subcategory;